module.exports = __webpack_public_path__ + "static/media/NL.41071c1c.png";